import { KeyRound, LogOut } from 'lucide-react';

import { iniciais } from '@/lib/formato';
import { DropdownMenu } from '@/ui/primitives/dropdown-menu';

interface MenuUsuarioProps {
  nome: string;
  email: string;
  papel?: string | undefined;
  aoTrocarSenha: () => void;
  aoSair: () => void;
}

export function MenuUsuario({ nome, email, papel, aoTrocarSenha, aoSair }: MenuUsuarioProps) {
  return (
    <DropdownMenu
      gatilho={
        <button
          type="button"
          aria-label={`Conta de ${nome}`}
          className="grid size-9 place-items-center rounded-pilula bg-marca text-sm font-semibold text-marca-texto ring-2 ring-superficie transition-transform duration-[var(--duracao-rapida)] hover:scale-105"
        >
          {iniciais(nome)}
        </button>
      }
      cabecalho={
        <div className="grid gap-0.5">
          <span className="font-medium">{nome}</span>
          <span className="text-xs text-texto-suave">{email}</span>
          {papel && <span className="text-xs text-marca">{papel}</span>}
        </div>
      }
      itens={[
        { rotulo: 'Trocar senha', icone: <KeyRound aria-hidden />, aoSelecionar: aoTrocarSenha },
        { rotulo: 'Sair', icone: <LogOut aria-hidden />, aoSelecionar: aoSair },
      ]}
    />
  );
}
